/* eslint-disable no-param-reassign */
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator/aiMusicGeneratorApi';
import { VegaBundle } from '../ai/types';

export const bundlesAdapter = createEntityAdapter<VegaBundle>({
  /**
   * Sort by created date, latest to earliest
   */
  sortComparer: (a, b) => b.createdAtTimestamp - a.createdAtTimestamp,
});

export const bundlesSlice = createSlice({
  name: 'bundles',
  initialState: bundlesAdapter.getInitialState({
    isLoading: false,
    isGenerating: false,
    areAllLoaded: false,
  }),
  extraReducers: (builder) => {
    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.getBundles.matchPending,
      (state) => {
        state.isLoading = true;
      }
    );
    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.getBundles.matchFulfilled,
      (state, { payload: { items, pagination } }) => {
        bundlesAdapter.setMany(state, items);
        state.isLoading = false;
        if (items.length < pagination.itemsPerPage) {
          state.areAllLoaded = true;
        }
      }
    );

    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.createBundle.matchPending,
      (state) => {
        state.isGenerating = true;
      }
    );
    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.createBundle.matchRejected,
      (state) => {
        state.isGenerating = false;
      }
    );
    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.createBundle.matchFulfilled,
      (state, { payload }) => {
        bundlesAdapter.setOne(state, payload);
      }
    );

    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.getBundleById.matchFulfilled,
      (state, { payload }) => {
        bundlesAdapter.setOne(state, payload);
        const { isFinished } = payload;
        if (isFinished) {
          state.isGenerating = false;
        }
      }
    );

    builder.addMatcher(
      aiMusicGeneratorApi.endpoints.getBundleById.matchRejected,
      (state) => {
        state.isGenerating = false;
      }
    );
  },
  reducers: {},
});

export const { actions, reducer } = bundlesSlice;
